import React, {Component} from 'react';
import './Verify.css';
import {verify} from '../../util/APIUtils';
import {Link, Redirect} from 'react-router-dom'
import Alert from 'react-s-alert';

class Verify extends Component {

    constructor() {
        super();
        this.state = {
            checkSuccess: false,
        }
    }

    componentDidMount() {
        const searchParams = new URLSearchParams(window.location.search);
        const code = searchParams.get('code');
        console.log(window.location.search);
        verify(code)
            .then(response => {
                Alert.success("Congratulations, your account has been verified.");
                this.setState({
                    checkSuccess: true
                });
            }).catch(error => {
            // this.props.history.push("/signup");
            // Alert.error((error && error.message) || 'Sorry, we could not verify account. It maybe already verified, or verification code is\n' +
            //     '                    incorrect.');
        });

        // If the OAuth2 login encounters an error, the user is redirected to the /login page with an error.
        // Here we display the error and then remove the error query parameter from the location.
        if (this.props.location.state && this.props.location.state.error) {
            setTimeout(() => {
                Alert.error(this.props.location.state.error, {
                    timeout: 5000
                });
                this.props.history.replace({
                    pathname: this.props.location.pathname,
                    state: {}
                });
            }, 100);
        }
    }

    render() {
        if(this.props.authenticated) {
            return <Redirect
                to={{
                pathname: "/",
                state: { from: this.props.location }
            }}/>;
        }

        return (
            <div className="container text-center">
                <h3>{ this.state.checkSuccess ? "Congratulations, your account has been verified." :
                    "Sorry, we could not verify account. It maybe already verified, or verification code is incorrect."}</h3>
                <h4><Link to="/login">Click here to Login</Link></h4>
            </div>
        );
    }
}

export default Verify



// WEBPACK FOOTER //
// ./src/user/verify/Verify.js